import type {
  ChangeAgendaQueuedSendSummaryItem,
  ChangeAgendaSendSummaryItem,
} from '../../types/changes';

function formatWhen(value?: string | null): string {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function describeAgendaEmailDispatch(params: {
  sentItems: ChangeAgendaSendSummaryItem[];
  queuedItems?: ChangeAgendaQueuedSendSummaryItem[];
}): { headline: string; modalParagraph: string; hasHistory: boolean } {
  const sent = params.sentItems || [];
  const queued = params.queuedItems || [];
  const parts: string[] = [];

  if (sent.length) {
    const sentLines = sent.map(
      (item) =>
        `${item.agenda_kind_label}: enviado em ${formatWhen(item.last_sent_at)} (${item.recipients_count} destinatário(s), registro #${item.send_log_id})`,
    );
    parts.push(`Já enviado — ${sentLines.join('; ')}.`);
  }

  if (queued.length) {
    const queueLines = queued.map(
      (item) =>
        `${item.agenda_kind_label}: agendado para ${formatWhen(item.send_at)} (fila #${item.queued_id})`,
    );
    parts.push(`Disparo na fila — ${queueLines.join('; ')}.`);
  }

  if (!parts.length) {
    return {
      headline: 'Nenhum e-mail desta pauta foi enviado nem agendado ainda.',
      modalParagraph: 'Ainda não há envio nem agendamento registrado para este item.',
      hasHistory: false,
    };
  }

  return {
    headline: parts.join(' '),
    modalParagraph: `${parts.join(' ')} Disparos pendentes podem ser cancelados na lista «Disparos agendados na fila». Para outro horário, cancele e envie de novo. Novos envios não apagam o histórico anterior.`,
    hasHistory: true,
  };
}

export function shortDispatchBadge(params: {
  sentItems: ChangeAgendaSendSummaryItem[];
  queuedItems?: ChangeAgendaQueuedSendSummaryItem[];
}): string | null {
  const queued = params.queuedItems?.length || 0;
  const sent = params.sentItems?.length || 0;
  if (queued && sent) return `${sent} enviado(s) · ${queued} agendado(s)`;
  if (queued) return queued === 1 ? '1 e-mail agendado' : `${queued} e-mails agendados`;
  if (sent) return sent === 1 ? 'E-mail já enviado' : `${sent} tipos já enviados`;
  return null;
}
